import { ChatRole } from 'types/index'
import clsx from 'clsx'
import { Button } from 'components/ui/Button'
import { useAppContext } from 'hooks/useAppContext'
import { updateChatRole } from 'api/index'
import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'

export type ChatRoleButtonProps = {
  role: ChatRole
  enabled?: boolean
}

const useUpdateChatRole = () => {
  const [loading, setLoading] = useState(false)

  const action = useCallback(async (role: ChatRole) => {
    try {
      setLoading(true)
      await updateChatRole(role)
      setLoading(false)
    } catch (error) {
      console.error({ error })
      setLoading(false)
    }
  }, [])

  return {
    update: action,
    loading,
  }
}

export const ChatRoleButton = ({ role, enabled }: ChatRoleButtonProps) => {
  const { buttonsCss } = useAppContext()
  const { t } = useTranslation()
  const { update } = useUpdateChatRole()

  return (
    <Button
      type="button"
      className={clsx('tw-px-4 tw-py-1 tw-text-center tw-text-sm tw-font-medium', {
        'tw-cursor-not-allowed': !enabled,
      })}
      // backgroundColor={
      //   item.isSelected && item.isSelected() ? buttonsCss.hoverBackgroundColor : buttonsCss.backgroundColor
      // }
      backgroundColor={buttonsCss.backgroundColor}
      color={buttonsCss.color}
      borderRadius={buttonsCss.borderRadius}
      borderWidth={buttonsCss.borderWidth}
      hoverborderWidth={buttonsCss.hoverborderWidth}
      borderColor={buttonsCss.borderColor}
      enableHover={buttonsCss.enableHover}
      hoverBackgroundColor={enabled ? buttonsCss.hoverBackgroundColor : buttonsCss.backgroundColor}
      onClick={() => update(role)}
      disabled={!enabled}
    >
      {t(role)}
    </Button>
  )
}
